module.exports = __webpack_public_path__ + "static/media/canada11.ce5d468a.jpg";